import React, { Component } from 'react';

import './Start.css';
import { Link } from 'react-router-dom';

class Start extends Component {
  render() {
    return (
      <div className="Start">
        <h3>Welcome to QbatesApp</h3>
        <button><Link to="/login">GET STARTED</Link></button>
      </div>
    );
  }
}

export default Start;


// WEBPACK FOOTER //
// ./src/Containers/Home/components/Start.js